var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h2", [_vm._v("Not found")]),
      _vm._v(" "),
      _c("p", [_vm._v("Can't access this section with this account")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }